import { FC } from 'react'
import { IconButton } from '@mui/material'
import toast from 'react-hot-toast'
import ToastPredictionToggleIcon from '../../svg/toast/ToastPredictionToggleIcon'

interface Props {
  enabled?: boolean
}

const HotToastTogglePrediction: FC<Props> = ({ enabled }) => (
  <div className="react-hot-toast__content-wrapper">
    Prediction mode is {enabled ? 'enabled' : 'disabled'}!
    <IconButton onClick={() => toast.dismiss()}>
      <ToastPredictionToggleIcon />
    </IconButton>
  </div>
)

export default HotToastTogglePrediction
